<script setup lang="ts">
definePageMeta({
  layout: 'fund',
})

useSetSEO()
useScrollRestoration()

const fundStore = useFundStore()
const { fundHistories } = storeToRefs(fundStore)
const fetchStatus = reactive({
  loading: false,
  error: false,
})

onBeforeMount(async () => {
  await fetchFundHistories()
})

// 펀딩 히스토리 목록
const fetchFundHistories = async () => {
  try {
    fetchStatus.loading = true
    fetchStatus.error = false
    await fundStore.fetchFundHistories(fundHistories.value.payload, true)
  } catch {
    fetchStatus.error = true
  } finally {
    fetchStatus.loading = false
  }
}
</script>

<template>
  <div class="page-history">
    <ClientOnly>
      <NovaLoadingIndicator v-if="fetchStatus.loading" />

      <NovaBoxEmptyMessage
        v-if="!fetchStatus.loading && fetchStatus.error"
        :message="$t('fund.histories.message.error')"
        :fill="true"
      />

      <NovaBoxEmptyMessage
        v-if="
          !fetchStatus.loading &&
          !fetchStatus.error &&
          !fundHistories.items.length
        "
        :message="$t('fund.histories.message.empty')"
        :fill="true"
      />

      <NovaBoxFundHistory
        v-if="
          !fetchStatus.loading &&
          !fetchStatus.error &&
          fundHistories.items.length
        "
      />
    </ClientOnly>

    <NuxtPage />
  </div>
</template>

<style lang="scss" scoped>
.page-history {
  display: flex;
  padding-bottom: 20px;

  @include mobile {
    flex-wrap: wrap;
    padding: 10px 10px 50px 10px;
    gap: 10px;
  }
}
</style>
